/**
 * Gets when the word "Mobile" exists inside of the string to match.
 * "\b" matches a word boundary position. With double "\b", we make sure it is a whole word and
 * not a substring from other word.
 * "Mobile" matches this same word on the string.
 * Regex used for the changes on {@link https://builderhomesite.atlassian.net/browse/NHS20-2125} to be able to
 * identify the mobile devices by its user agent.
 */
const isMobileUserAgent = /\bMobile\b/

/**
 * Determines if the current device user agent is mobile.
 * The current way to determine it is to check the User Agent string, and verify
 * if it contains the word "Mobile" on there.
 * By business, we manage the tablet and desktop devices as desktop.
 * @returns A bool value indicating whether the device user agent is mobile.
 */
const matchesMobileUserAgent = () => isMobileUserAgent.test(navigator.userAgent);

export default matchesMobileUserAgent;